import { render, staticRenderFns } from "./ReviewCarousel.vue?vue&type=template&id=64393c64&"
import script from "./ReviewCarousel.vue?vue&type=script&lang=js&"
export * from "./ReviewCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports